<div *ngIf="dynamicForm">
  <!-- Intro Message -->
  <div class="mb-3">
    <h2 class="font-weight-bold mb-1">
      {{'SETUP_YOUR_ENVIRONMENT' | translate}}
    </h2>
    <p class="setup-description mb-0" [innerHTML]="'SETUP_YOUR_ENVIRONMENT_DESCRIPTION' | translate">
    </p>
  </div>
  <form [formGroup]="dynamicForm">
    <div class="form-group mb-2" *ngFor="let field of dynamicParameters">
      <!-- Label -->
      <label class="dynamic-label mb-2 mt-3">
        {{ field.userFriendlyLabel }}
        <span class="text-danger">*</span>
      </label>

      <!-- Text -->
      <ng-container *ngIf="field.inputType === 'text'">
        <input type="text" class="form-control dynamic-input" [formControlName]="field.name">

        <small class="text-danger" *ngIf="dynamicForm.get(field.name)?.invalid &&
                 dynamicForm.get(field.name)?.touched">
          {{ 'REQUIRED_FIELD' | translate }}
        </small>
      </ng-container>

      <!-- Password -->
      <ng-container *ngIf="field.inputType === 'password'">
        <input type="password" class="form-control dynamic-input" [formControlName]="field.name">

        <!-- Required -->
        <small
          class="text-danger"
          *ngIf="
            dynamicForm.get(field.name)?.hasError('required') &&
            dynamicForm.get(field.name)?.touched">
          {{ 'REQUIRED_FIELD' | translate }}
        </small>

        <!-- Custom validator -->
        <small
          class="text-danger"
          *ngIf="
            dynamicForm.get(field.name)?.hasError('atSymbolNotAllowed') &&
            dynamicForm.get(field.name)?.touched">
          {{ '@_NOT_ALLOWED' | translate }}
        </small>
      </ng-container>

      <!-- Number -->
      <ng-container *ngIf="field.inputType === 'number'">
        <input type="number" class="form-control dynamic-input" [formControlName]="field.name">

        <small class="text-danger" *ngIf="dynamicForm.get(field.name)?.invalid &&
                 dynamicForm.get(field.name)?.touched">
          {{ 'REQUIRED_FIELD' | translate }}
        </small>
      </ng-container>

      <!-- Dropdown -->
      <ng-container *ngIf="field.inputType === 'list'">

        <select class="form-control dynamic-input" [formControlName]="field.name">

          <option value="" disabled>
            Select {{ field.userFriendlyLabel }}
          </option>

          <option *ngFor="let item of field.inputValues" [value]="item.value || item">

            {{ item.displayName || item }}

          </option>

        </select>

        <small class="text-danger" *ngIf="dynamicForm.get(field.name)?.invalid &&
                 dynamicForm.get(field.name)?.touched">
          {{ 'REQUIRED_FIELD' | translate }}
        </small>

      </ng-container>

      <!-- Checkbox -->
      <ng-container *ngIf="field.inputType === 'checkbox'">

        <div class="form-check mt-2">

          <input type="checkbox" class="form-check-input checkbox-lg" [formControlName]="field.name">

          <label class="form-check-label ml-2">
            {{ field.userFriendlyLabel }}
          </label>

        </div>

      </ng-container>

    </div>

    <!-- <div class="mt-5 text-right">
      <teams-button [index]="'submitDynamicForm'" [title]="'SUBMIT_LAUNCH_LAB' | translate" [disabled]="(
            lab?.Regions !== null &&
            (!lab?.UserSelectedRegion || lab?.UserSelectedRegion?.length === 0)
          ) || dynamicForm.invalid" (buttonClick)="onSubmit()">
      </teams-button>
    </div> -->
    <div class="mt-5 d-flex justify-content-between align-items-center">

      <div class="deploy-message">
        {{ 'LAB_DEPLOY_MESSAGE' | translate }}
      </div>
    
      <teams-button
        [index]="'submitDynamicForm'"
        [title]="'SUBMIT_LAUNCH_LAB' | translate"
        [disabled]="(
          lab?.Regions !== null &&
          (!lab?.UserSelectedRegion || lab?.UserSelectedRegion?.length === 0)
        ) || dynamicForm.invalid"
        (buttonClick)="onSubmit()">
      </teams-button>
    
    </div>
  </form>
</div>